import { useEffect, type ReactNode } from "react";

interface LunchEditorSheetProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

/**
 * Bottom sheet под десктоп с черновата на обедното меню — рамката на
 * OrderSheet (скрим z-60, панел z-70, горни ъгли 22px, до 78% височина).
 * Escape и клик в скрима го затварят.
 */
export const LunchEditorSheet = ({ open, onClose, children }: LunchEditorSheetProps) => {
  useEffect(() => {
    if (!open) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div className="fixed inset-0 z-[60] bg-scrim" onClick={onClose} />
      <div className="dk-elevated fixed inset-x-0 bottom-0 z-[70] flex max-h-[78%] flex-col overflow-hidden rounded-t-[22px] bg-pos-card shadow-[0_-14px_44px_rgba(0,0,0,.25)]">
        <span aria-hidden className="mx-auto mb-1 mt-2 h-1 w-10 shrink-0 rounded-sm bg-pos-ctl" />
        {children}
      </div>
    </>
  );
};
